import {CartItems} from '../features/cart-items';
import {register} from '../vendor/theme-scripts/theme-sections';
import {initQtySection} from '../features/quantity-selector';
import accordion from '../features/accordion';
import {ShippingCalculator} from '../features/cart-shipping';
import {ProductAddButton} from '../features/product-add';

const selectors = {
  ajaxDisable: 'data-ajax-disable',
  shipping: '[data-shipping-estimate-form]',
  input: '[data-update-cart]',
  update: '[data-update-button]',
  bottom: '[data-cart-bottom]',
  upsellProduct: '[data-upsell-holder]',
  upsellButton: '[data-add-action-wrapper]',
};

const cartSection = {
  onLoad() {
    this.disabled = this.container.getAttribute(selectors.ajaxDisable) == 'true';
    if (this.disabled) {
      this.cart = new DiabledCart(this);
      return;
    }

    this.cart = new CartItems(this);
    const initPromise = this.cart.init();
    initPromise.then(() => {
      this.cart.loadHTML();
    });

    const hasShipping = this.container.querySelector(selectors.shipping);
    if (hasShipping) {
      new ShippingCalculator(this);
    }
  },
};

class DiabledCart {
  constructor(section) {
    this.container = section.container;
    this.inputs = this.container.querySelectorAll(selectors.input);
    this.quantityWrappers = this.container.querySelectorAll(selectors.qty);
    this.updateBtn = this.container.querySelector(selectors.update);
    this.upsellProduct = this.container.querySelector(selectors.upsellProduct);
    this.initQuantity();
    this.initInputs();
    if (this.upsellProduct) {
      this.moveUpsell();
    }
  }

  initQuantity() {
    initQtySection(this.container);
  }

  moveUpsell() {
    const bottom = this.container.querySelector(selectors.bottom);
    bottom.insertBefore(this.upsellProduct, bottom.firstChild);

    const upsellButton = this.container.querySelector(selectors.upsellButton);
    new ProductAddButton(upsellButton);
  }

  initInputs() {
    this.inputs.forEach((input) => {
      input.addEventListener(
        'change',
        function () {
          this.updateBtn.classList.add('cart--dirty');
          this.updateBtn.classList.add('heartBeat');
          setTimeout(
            function () {
              this.updateBtn.classList.remove('heartBeat');
            }.bind(this),
            1300
          );
        }.bind(this)
      );
    });
  }
}

register('cart', [cartSection, accordion]);
